// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"EditTagModal_saveButton__hbwrQ","cancelButton":"EditTagModal_cancelButton__BvOBf"};